import { render, staticRenderFns } from "./ScrollCircle.vue?vue&type=template&id=20c9a328&"
import script from "./ScrollCircle.vue?vue&type=script&lang=js&"
export * from "./ScrollCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports